import React from 'react';
import { Card, Form, Select, Switch, Button, Divider, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import './index.css';

const Settings = () => {
  const { t, i18n } = useTranslation();
  const [form] = Form.useForm();

  const handleLanguageChange = (value) => {
    i18n.changeLanguage(value);
  };

  const onFinish = (values) => {
    console.log('Settings saved:', values);
  };

  return (
    <div className="settings-page">
      <h2>{t('user.settings')}</h2>
      <Card className="settings-card">
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          initialValues={{
            language: i18n.language,
            notifications: true,
            autoSave: true,
            theme: 'light'
          }}
        >
          <Form.Item
            name="language"
            label={t('common.language')}
          >
            <Select onChange={handleLanguageChange}>
              <Select.Option value="zh">中文</Select.Option>
              <Select.Option value="en">English</Select.Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="theme"
            label="主题"
          >
            <Select>
              <Select.Option value="light">浅色主题</Select.Option>
              <Select.Option value="dark">深色主题</Select.Option>
            </Select>
          </Form.Item>

          <Divider />

          <Form.Item
            name="notifications"
            label="消息通知"
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>

          <Form.Item
            name="autoSave"
            label="自动保存"
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>

          <Form.Item
            name="emailNotifications"
            label="邮件通知"
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>

          <Divider />

          <Form.Item>
            <Space>
              <Button type="primary" htmlType="submit">
                {t('common.save')}
              </Button>
              <Button htmlType="button" onClick={() => form.resetFields()}>
                {t('common.reset')}
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default Settings; 